<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     刷新视图组件
  | @Version:   2019-01-15  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->
<template>
  <div />
</template>

<script>
export default {
  name: 'Refresh',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$router.replace({
        path: from.path,
        query: {
          ...to.query,
          time: +new Date() + ''
        }
      })
    })
  }
}
</script>
